import { getUserToken } from '../functions.js'
import { getServerApi } from '../config/deployment'
import { performRequest_GET, performRequest_POST } from '../platform/utils/http/httpService'
import { getCurrentUserToken } from '../platform/auth/services/authService'
import {captureMessage, captureException} from '@/utils/reporting/reportingService.js'
import store from '../vuex/store.js'

let envUri = getServerApi()
let dealsUri = envUri + '/api/deals'
let bookingConfirmationDecisionUri = envUri + '/api/bookings/confirmation'

export const createDeal = ({property, lesseeDet, lessorDet, contractDetails, lessorAccountId}) => {
  return new Promise((resolve, reject) => {
    getCurrentUserToken()
      .then(token => {
        var headers = { "Authorization": token };
        var data = {
          lessorAccountId: lessorAccountId,
          dealCommand: {
            property: {
              maaklerID: property.maaklerID,
              address: property.location.address,
              _id: property._id
            },
            lesseeDet: lesseeDet,
            lessorDet: lessorDet,
            contractDetails: contractDetails
          }
        }
        return performRequest_POST(dealsUri, data, headers)
      })
      .then(resp => {
        if (resp.success) resolve(resp.response.data.body)
        else reject(resp.error)
      })
      .catch(err => {
        console.log("createDeal | err:", err)
        reject(err)
      })
  })
}

export const getAccountDealIds = ({ accountId, viewRole }) => {
  return new Promise((resolve, reject) => {
    getCurrentUserToken()
      .then(token => {
        var headers = { "Authorization": token };
        return performRequest_GET(dealsUri, { accountId: accountId, viewRole: viewRole }, headers)
      })
      .then(resp => {
        if (resp.success) resolve(resp.response.data.body)
        else reject(resp.error)
      })
      .catch(err => {
        console.log("getAccountDealIds | err:", err)
        reject(err)
      })
  })
}

export const getDealById = (dealId, accountId) => {
  return new Promise((resolve, reject) => {
    getCurrentUserToken()
      .then(token => {
        var headers = { "Authorization": token };
        return performRequest_GET(dealsUri + "/" + dealId, { accountId: accountId }, headers)
      })
      .then(resp => {
        if (resp.success) resolve(resp.response.data.body)
        else reject(resp.error)
      })
      .catch(err => {
        console.log("getDealById | err:", err)
        reject(err)
      })
  })
}

export const makeBookingConfirmationDecision = ({bookingType, bookingId, decision, contractType, contractTemplateId, propertyId, accountId}) => {
  return getUserToken()
    .then(token => {

      var accountId = store.getters.selectedAccount
      if(!accountId) return { success: false, message: "no account selected" }
      var headers = { "Authorization": token };
      var data = {
        bookingId: bookingId,
        decision: decision,
        contractType: contractType,
        contractTemplateId:contractTemplateId,
        propertyId:propertyId,
        accountId: accountId,
        bookingType: bookingType
      }
      return performRequest_POST(bookingConfirmationDecisionUri, data, headers)
        .then(res => {
          if(res.success){
            return { success: true, message: "success", result: res.response.data.body }
          }else throw res.error
        })
        .catch(err => {
          console.log('makeBookingConfirmationDecision > err:',err);
          captureException(err)
          return { success: false, message: err }
        })
    })
}

export const createBADeal = (dealCommand) => {
  return getUserToken()
    .then(token => {
      var headers = { "Authorization": token };
      return performRequest_POST(dealsUri + "/booking-application", dealCommand, headers)
        .then(res => {
          if(res.success){
            if (res.response.data && res.response.data.message) {
              return { success: true, message: res.response.data.message, result: res.response.data.body }
            } else throw "Cannot parse response payload"
          }else throw res.error
        })
        .catch(err => {
          console.log('createBADeal > err:',err);
          captureException(err)
          return { success: false, message: err }
        })
    })
}

export const getDeals = async ({ accountId, viewRole, page = 0, limit = 25 }) => {
  try{
    const token = await getCurrentUserToken();
    const response = await performRequest_GET(
        `${dealsUri}/all`,
        { accountId: accountId, viewRole: viewRole, page, limit },
        { "Authorization": token }
    );
    if (!response.success) {
        return [];
    }

    return response.response.data.body || [];
  }catch(err){
    return []
  }
};

export const filterDeals = async ({ accountId, searchString, viewRole, page = 0, limit = 250 }) => {
    try {
        const token = await getCurrentUserToken();
        const response = await performRequest_GET(
            `${dealsUri}/filter`,
            { accountId, searchString, viewRole, page, limit },
            { "Authorization": token }
        );
        if (!response.success) {
            return [];
        }

        return response.response.data.body || [];
    }
    catch (err) {
        return [];
    }
};


// WEBPACK FOOTER //
// ./src/bookings/bookingsService.js